namespace SorAraBul.Common {

    export interface SmsCodeDialogOptions {
        phone?: string;
        title?: string;
        /** jQuery / native Promise / sync hepsi kabul */
        resend?: () => JQueryPromise<any> | PromiseLike<any> | void;
        resendCooldown?: number;
        autoSubmitLength?: number;
    }

    @Serenity.Decorators.registerClass()
    export class SmsCodeDialog extends Serenity.TemplatedDialog<SmsCodeDialogOptions> {
        private codeInput: JQuery;
        private resendBtn: JQuery;
        private cooldownSpan: JQuery;
        private countdownTimer: number | null = null;

        /** Serenity 6 için: JQueryPromise döndür (then/fail) */
        static ask(options?: SmsCodeDialogOptions): JQueryPromise<string | null> {
            const d = $.Deferred<string | null>(); // jQuery Deferred

            const dlg = new SmsCodeDialog(options);

            dlg.onCancel = () => {
                d.resolve(null);
                dlg.dialogClose();
            };

            dlg.onSuccess = (code) => {
                d.resolve(code);
                dlg.dialogClose();
            };

            // opsiyonel hata kanalı
            dlg.onError = (err) => {
                d.reject(err);
                dlg.dialogClose();
            };

            dlg.dialogOpen();
            return d.promise(); // JQueryPromise<string|null>
        }

        // dışarıya takılmak istersen:
        public onSuccess: (code: string) => void = _ => { };
        public onCancel: () => void = () => { };
        public onError: (err: any) => void = _ => { };

        protected getDialogOptions() {
            const opt = super.getDialogOptions();
            opt.modal = true;
            opt.title = this.options?.title ?? 'SMS Doğrulama Kodu';
            opt.width = 420;
            return opt;
        }

        protected getTemplate() {
            return `<div class="p-3">
                <div class="mb-2 text-muted">
                    <i class="fa fa-sms"></i>
                    <span>Telefon${Q.coalesce(this.options?.phone, '') ? ':' : ''}</span>
                    <strong class="phone"></strong>
                </div>

                <div class="mb-2">
                    <input id="Code" class="form-control input-lg" maxlength="6"
                           placeholder="6 haneli kod" autocomplete="one-time-code"
                           inputmode="numeric" pattern="[0-9]*" />
                    <div class="help-block small mt-1">
                        Kod ulaşmadı mı?
                        <button type="button" id="Resend" class="btn btn-link p-0 align-baseline">
                            Yeniden gönder
                        </button>
                        <span id="Cooldown" class="text-muted d-none"></span>
                    </div>
                </div>
            </div>`;
        }

        protected onDialogOpen() {
            super.onDialogOpen();

            this.codeInput = this.element.find('#Code');
            this.resendBtn = this.element.find('#Resend');
            this.cooldownSpan = this.element.find('#Cooldown');

            if (this.options?.phone)
                this.element.find('.phone').text(this.options.phone);
                
            // yalnız rakam & auto-submit
            this.codeInput.on('input', () => {
                const digits = (this.codeInput.val() as string || '').replace(/\D+/g, '').slice(0, 6);
                this.codeInput.val(digits);

                //const target = this.options?.autoSubmitLength ?? 6;
                //if (digits.length === target) {
                //    window.setTimeout(() => this.okClick(), 50);
                //}
            });

            this.codeInput.on('keydown', (e) => {
                if (e.key === 'Enter') { e.preventDefault(); this.okClick(); }
                else if (e.key === 'Escape') { e.preventDefault(); this.cancelClick(); }
            });

            // yeniden gönder (jQueryPromise / Promise / void destekler)
            this.resendBtn.on('click', () => {
                if (this.resendBtn.prop('disabled')) return;

                const run = this.options?.resend;
                if (!run) { Q.notifyInfo('Yeniden gönderme tanımlı değil.'); return; }

                this.resendBtn.prop('disabled', true);

                const done = () => {
                    Q.notifySuccess('Kod yeniden gönderildi.');
                    this.startCooldown(this.options?.resendCooldown ?? 60);
                };
                const fail = (err?: any) => {
                    Q.notifyError('Kod gönderilemedi.');
                    this.resendBtn.prop('disabled', false);
                    if (err) this.onError(err);
                };

                try {
                    const r = run();
                    // jQueryPromise ise:
                    if (r && typeof (r as any).then === 'function' && typeof (r as any).fail === 'function') {
                        (r as JQueryPromise<any>).then(done).fail(fail);
                    }
                    // native Promise/thenable ise:
                    else if (r && typeof (r as any).then === 'function') {
                        (r as PromiseLike<any>).then(() => done(), fail);
                    }
                    // sync ise:
                    else {
                        done();
                    }
                } catch (e) {
                    fail(e);
                }
            });

            this.codeInput.focus();

            if (this.options?.resendCooldown && this.options.resendCooldown > 0)
                this.startCooldown(this.options.resendCooldown);
        }

        protected getDialogButtons(): Serenity.DialogButton[] {
            return [
                { text: 'İptal', cssClass: 'cancel-button', click: () => this.cancelClick() },
                { text: 'Onayla', cssClass: 'btn-primary', click: () => this.okClick() }
                
            ];
        }

        protected okClick() {
            const code = (this.codeInput.val() as string || '').trim();
            if (code.length !== 6) {
                Q.notifyError('Lütfen 6 haneli kod girin.');
                this.codeInput.focus();
                return;
            }
            this.onSuccess(code);
        }

        private cancelClick() { this.onCancel(); }

        private startCooldown(seconds: number) {
            let remain = seconds;
            this.cooldownSpan.removeClass('d-none');

            const tick = () => {
                this.cooldownSpan.text(` (${remain}s)`);
                remain--;
                if (remain < 0) { this.clearCooldown(); return; }
                this.countdownTimer = window.setTimeout(tick, 1000);
            };
            tick();
        }

        private clearCooldown() {
            if (this.countdownTimer != null) {
                window.clearTimeout(this.countdownTimer);
                this.countdownTimer = null;
            }
            this.cooldownSpan.addClass('d-none').text('');
            this.resendBtn.prop('disabled', false);
        }
    }
}
